/* eslint-disable import/no-internal-modules */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-use-before-define */

// MentionUI is mostly from official CK repo. We've made some changes so that we
// can show our own mention popup instead of CK popup. Event though
// CK solves almost all challenges including finding the perfect position of popup,
// closing poup on esc etc, we're still keeping most of the logic here
// and removed unwanted ones.
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TextWatcher from '@ckeditor/ckeditor5-typing/src/textwatcher';
import ContextualBalloon from '@ckeditor/ckeditor5-ui/src/panel/balloon/contextualballoon';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import env from '@ckeditor/ckeditor5-utils/src/env';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import { queueMacrotask } from 'utils/macrotask';

// The key codes that mention UI handles when it is open.
const handledKeyCodes = [
  keyCodes.arrowup,
  keyCodes.arrowdown,
  keyCodes.enter,
  keyCodes.tab,
  keyCodes.esc,
];

export class MentionUI extends Plugin {
  static get pluginName() {
    return 'MentionUI';
  }

  static get requires() {
    return [ContextualBalloon];
  }

  constructor(editor) {
    super(editor);

    this._mentionsConfigurations = new Map();

    editor.config.define('mention', { feeds: [] });
  }

  init() {
    const { editor } = this;

    this._balloon = editor.plugins.get(ContextualBalloon);
    // Key listener that handles navigation in mention view.
    editor.editing.view.document.on(
      'keydown',
      (evt, data) => {
        if (isHandledKey(data.keyCode) && this._isUIVisible) {
          data.preventDefault();
          evt.stop(); // Required for Enter key overriding.

          if (data.keyCode === keyCodes.arrowdown) {
            this.editor.fire('mentionPopup:selectNext');
          }

          if (data.keyCode === keyCodes.arrowup) {
            this.editor.fire('mentionPopup:selectPrevious');
          }

          if (
            data.keyCode === keyCodes.enter ||
            data.keyCode === keyCodes.tab
          ) {
            this.editor.fire('mentionPopup:executeSelected');
          }

          if (data.keyCode === keyCodes.esc) {
            this._hideUIAndRemoveMarker();
          }
        }
      },
      { priority: 'highest' },
    ); // Required to override the Enter key.

    const feeds = editor.config.get('mention.feeds');

    for (const mentionDescription of feeds) {
      const { marker } = mentionDescription;

      if (!isValidMentionMarker(marker)) {
        throw new CKEditorError('mentionconfig-incorrect-marker', null);
      }

      const minimumCharacters = mentionDescription.minimumCharacters || 0;

      this._setupTextWatcherForFeed(marker, minimumCharacters);
    }
  }

  destroy() {
    super.destroy();
  }

  get _isUIVisible() {
    return this.UIVisible;
  }

  _setupTextWatcherForFeed(marker, minimumCharacters) {
    const { editor } = this;

    const watcher = new TextWatcher(
      editor.model,
      createTestCallback(marker, minimumCharacters),
    );

    watcher.on('matched', (evt, data) => {
      const { selection } = editor.model.document;
      const { focus } = selection;

      if (hasExistingMention(focus)) {
        this._hideUIAndRemoveMarker();

        return;
      }

      const feedText = requestFeedText(marker, data.text);
      const matchedTextLength = marker.length + feedText.length;

      // Create a marker range.
      const start = focus.getShiftedBy(-matchedTextLength);
      const end = focus.getShiftedBy(-feedText.length);

      const markerRange = editor.model.createRange(start, end);

      if (checkIfStillInCompletionMode(editor)) {
        const mentionMarker = editor.model.markers.get('mention');

        // Update the marker - user might've moved the selection to other mention trigger.
        editor.model.change((writer) => {
          writer.updateMarker(mentionMarker, { range: markerRange });
        });
      } else {
        editor.model.change((writer) => {
          writer.addMarker('mention', {
            range: markerRange,
            usingOperation: false,
            affectsData: false,
          });
        });
      }
      this.editor.fire('mentionPopup:query', feedText);
      this._handleWatcherMatchResponse(marker);
    });

    watcher.on('unmatched', () => {
      this._hideUIAndRemoveMarker();
    });

    const mentionCommand = editor.commands.get('mention');

    watcher.bind('isEnabled').to(mentionCommand);

    return watcher;
  }

  _handleWatcherMatchResponse() {
    // If the marker is not in the document happens when the selection had changed and the 'mention' marker was removed.
    if (!checkIfStillInCompletionMode(this.editor)) {
      return;
    }

    const mentionMarker = this.editor.model.markers.get('mention');

    this._showOrUpdateUI(mentionMarker);
  }

  _showOrUpdateUI() {
    if (!this.UIVisible) {
      const selObj = window.getSelection();
      const range = selObj.getRangeAt(0);
      const positionFromRange = range.getBoundingClientRect();

      if (positionFromRange.left > 0) {
        this.editor.fire('mentionPopup:render', {
          position: {
            left: positionFromRange.left,
            top: positionFromRange.top,
          },
        });
      } else {
        // In task description rte, sometimes this calculation breaks.
        // so re-calculating again. this is an escape hatch for the time being
        // TODO: @asimkt find why task description rte is not giving the position correctly.

        queueMacrotask(() => {
          const selObjNew = window.getSelection();
          const rangeNew = selObjNew.getRangeAt(0);
          const positionFromRangeNew = rangeNew.getBoundingClientRect();

          this.editor.fire('mentionPopup:render', {
            position: {
              left: positionFromRangeNew.left,
              top: positionFromRangeNew.top,
            },
          });
        });
      }
    }
    this.UIVisible = true;
  }

  _hideUIAndRemoveMarker() {
    this.editor.fire('mentionPopup:remove');
    if (checkIfStillInCompletionMode(this.editor)) {
      this.editor.model.change((writer) => writer.removeMarker('mention'));
    }
    this.UIVisible = false;
  }
}

export function createRegExp(marker, minimumCharacters) {
  const numberOfCharacters =
    minimumCharacters === 0 ? '*' : `{${minimumCharacters},}`;

  const openAfterCharacters = env.features.isRegExpUnicodePropertySupported
    ? '\\p{Ps}\\p{Pi}"\''
    : '\\(\\[{"\'';

  const pattern = `(?:^|[ ${openAfterCharacters}])([${marker}])(.${numberOfCharacters})$`;
  // If we don't want to support spaces, uncommenting `pattern` and `mentionCharacters` would be a good starting point.
  // const mentionCharacters = '\\S';
  // const pattern = `(?:^|[ ${openAfterCharacters}])([${marker}])([${mentionCharacters}]${numberOfCharacters})$`;

  return new RegExp(pattern, 'u');
}

function createTestCallback(marker, minimumCharacters) {
  const regExp = createRegExp(marker, minimumCharacters);

  return (text) => regExp.test(text);
}

function requestFeedText(marker, text) {
  const regExp = createRegExp(marker, 0);

  const match = text.match(regExp);

  return match[2];
}

function isHandledKey(keyCode) {
  return handledKeyCodes.includes(keyCode);
}

function hasExistingMention(position) {
  const hasMention =
    position.textNode && position.textNode.hasAttribute('mention');

  const { nodeBefore } = position;

  return (
    hasMention ||
    (nodeBefore && nodeBefore.is('$text') && nodeBefore.hasAttribute('mention'))
  );
}

function isValidMentionMarker(marker) {
  return marker && marker.length === 1;
}

function checkIfStillInCompletionMode(editor) {
  return editor.model.markers.has('mention');
}
